import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/UseAuth';
// --- INICIO DE LA MODIFICACIÓN 1 ---
import { useTranslation } from 'react-i18next';
// --- FIN DE LA MODIFICACIÓN 1 ---

function MyContentLayout({ title }) {
  const { user, loading } = useAuth();
  // --- INICIO DE LA MODIFICACIÓN 2 ---
  const { t } = useTranslation();
  const location = useLocation(); // Se añade useLocation para la redirección
  // --- FIN DE LA MODIFICACIÓN 2 ---

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center h-64">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-primary mb-4"></div>
        {/* --- INICIO DE LA MODIFICACIÓN 3 --- */}
        <p className="text-neutral-600 dark:text-neutral-300 text-lg">
          {t('common.loading', 'Cargando...')}
        </p>
        {/* --- FIN DE LA MODIFICACIÓN 3 --- */}
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} />;
  }

  return (
    <div className="min-h-screen bg-neutral-50 dark:bg-neutral-900">
      <div className="max-w-6xl mx-auto flex gap-6 py-8">
        {/* Contenido principal */}
        <main className="flex-1">
          {title && (
            <h1 className="text-2xl font-bold text-neutral-800 dark:text-white mb-6">
              {title}
            </h1>
          )}
          <div className="bg-white dark:bg-neutral-800 rounded-2xl shadow-card p-6 min-h-[60vh]">
            <Outlet context={{ user }} />
          </div>
        </main>
      </div>
    </div>
  );
}

export default MyContentLayout;
